module.exports = __webpack_public_path__ + "img/蒙版组 132.973838b2.png";